import React, { useEffect, useState } from "react";
// css comes in groupWiseQuery.css
import axios from "../../../axios";
import CreateNewQuery from "../Create Query/CreateNewQuery";
import Form from "react-bootstrap/Form";
import FilterBox from "./Filter_Box/FilterBox";
import { IP } from "../../../internalServer";
import { Popup } from "semantic-ui-react";
import GroupMemberList from "./GroupMemberList";
import Select from "react-select";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import DetailsImagePopup from "../../PopImage/DetailsImagePopup";
import queryImage from "../../../images/Query_Process_Flow.png"
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import assets from "../../../assets/assets";
import DatePicker from "react-datepicker";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { PlusCircle } from "lucide-react";


const QueryHeader = ({
  socket,
  editQueryData,
  setEditQueryData,
  setFilter,
  filter,
  change,
  setQuery,
  query,
  groupData,
  click,
  setClick,
  initialQuery,
  setIsGettingData,
  setIsPreventApiCall,
  handleRefresh,
  getQuery
}) => {
  const [click1, setClick1] = useState(false);
  const [option, setOption] = useState("");
  const [openImg, setOpenImg] = useState(false)
  const [checked, setChecked] = useState({
    sortChecked: 2,
    timeChecked: 1,
  });
  const navigate = useNavigate()
  const { state } = useLocation()
  const [activeHeader, setActiveHeader] = useState("all");
  const currentUser = useSelector((state) => state.user.currentUser);

  const { name, tag, date, status, limit, page, sortBy, time, } = filter;

  const handleClick = () => {
    setClick(true);
    change(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setQuery([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };

  const ActiveHeaderFunction = (name) => {
    setActiveHeader(name);
  };

  useEffect(() => {
    setFilter(prev => ({
      ...prev,
      page: 1,
      status: activeHeader,
    }));
  }, [activeHeader]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "45px",
      width: "172px",
      borderRadius: "6px",
      padding: " 1px",
      border: "1px solid #F4F8FB",
      fontFamily: "MinecrafterReg.ttf",
      background: "#F8F9FD",
      fontSize: "12px",
    }),
    menu: (provided, state) => ({
      ...provided,
      // width: state.selectProps.menuWidth || 'auto', // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const optionsQuery = [
    { value: "all", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "approved", label: "Active" },
    { value: "resolved", label: "Resolved" },
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setFilter({
      ...filter,
      page: 1,
      status: selectedOption.value,
    });
    setQuery([]);
  };

  // useEffect(() => {
  //   getQuery();
  //   eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchClick, status]);
  //This method use for refresh and clear search
  const getQueryNew = async () => {
    setIsGettingData(true)
    try {
      let response = await axios.get(
        `/query/getForStudent/${currentUser?.id}/groupId/${state.groupId}`
      );
      setQuery(response.data.data);
    } catch (error) {
      console.log(error);
    }
    setIsGettingData(false)
  };

  return (
    <div className="bg-white">
      <div className="d-flex gap-2 align-items-center" >
        <IoIosArrowBack
          onClick={() => navigate("/EngagementQuery")}
          style={{ cursor: "pointer" }}
        />

        <div
          className="d-flex flex-column gap-1"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/EngagementQuery")}
        >
          <span className="text-sm">
            Dashboard / Engagement / Query
          </span>
        </div>
      </div>
      <div className="w-full px-3 mt-3 d-flex align-items-center a query_channel_header">
        <div className="w-full cursor-pointer gap-2 p-2 flex items-center justify-between bg-[#f4f9fb]">
          <div className="flex gap-2 items-center">
            <img
              src={
                groupData?.profile_picture
                  ? IP + groupData?.profile_picture.replace(/^\./, "")
                  : assets.QueryImg
              }
              className="query_profileimg"
              alt="img"
              onError={(e) => {
                e.target.src = assets.QueryImg
              }}
            />
            <span className="query_channelName">{groupData?.name}</span>
            <div className="query_status_img">
              <img
                src="/images/memberListIcon.png"
                className="cicle_statusImage2"
                alt=""
                style={{ width: "31px", height: "30px", borderRadius: "50%", border: "1px solid gray" }}
              />
              <Popup
                on="click"
                className="completed_list"
                trigger={
                  <div className="nth_person" style={{ cursor: "pointer" }}>{groupData?.member?.length}</div>
                }
                content={
                  <GroupMemberList totalMember={groupData?.member?.length} />
                }
                position=" right "
              />
            </div>
          </div>
          <div className="flex gap-4 items-center">
            <div onClick={(e) => setOpenImg(true)} className="text-red-600 text-[13px]">*Click to Know Details</div>
            <div>
              {!click &&
                !Object.keys(editQueryData).length > 0 &&
                initialQuery.length > 0 && (
                  <>
                    <button
                      className="btn btn-light creaeQueryBtn"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                      onClick={() => setClick(true)}
                    >
                      <PlusCircle size={16} className="me-1" />
                      <span className="font-semibold">Create Query</span>
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 p-0 w-full">
        <div className="w-full flex justify-center items-center gap-5">
          {!Object.keys(editQueryData).length > 0 &&
            initialQuery.length > 0 && (
              <>
                <div className="col-md-5 d-flex align-items-center justify-content-between main_button_box1">
                  <button
                    className={` poppins-semibold  ${activeHeader === "all"
                      ? "active main_three_button_active orange-text poppins-semibold "
                      : "main_three_button "
                      }`}
                    onClick={() => ActiveHeaderFunction("all")}
                  >
                    All
                  </button>

                  <button
                    className={`  poppins-semibold  ${activeHeader === "approved"
                      ? "active main_three_button_active orange-text poppins-semibold "
                      : "main_three_button "
                      }`}
                    onClick={() => ActiveHeaderFunction("approved")}
                  >
                    Active
                  </button>

                  <button
                    className={`  poppins-semibold  ${activeHeader === "pending"
                      ? "active main_three_button_active orange-text poppins-semibold "
                      : "main_three_button "
                      }`}
                    onClick={() => ActiveHeaderFunction("pending")}
                  >
                    Pending
                  </button>

                  <button
                    className={`  poppins-semibold  ${activeHeader === "resolved"
                      ? "active main_three_button_active orange-text poppins-semibold "
                      : "main_three_button "
                      }`}
                    onClick={() => ActiveHeaderFunction("resolved")}
                  >
                    Resolved
                  </button>
                </div>

                <div className=" header_right_box d-flex align-items-center justify-content-between w-full">
                  <div className="search_container d-flex align-items-center ">
                    <div className="dropdown">
                      <Form.Select
                        style={{ border: "none" }}
                        className="search_dropdown"
                        size="sm"
                        value={option}
                        onChange={(e) => {
                          setOption(e.target.value);
                          setFilter({
                            ...filter,
                            name: "",
                            tag: "",
                            date: null,
                            page: 1,
                          });
                        }}
                      >
                        <option value="">Search by Type</option>
                        <option value="Tag">Tag</option>
                        <option value="Name">Creator</option>
                        <option value="Date">Date</option>
                      </Form.Select>
                    </div>
                    <div className="search_input_cont">
                      {option === "Date" ? (
                        <DatePicker
                          selected={date}
                          placeholderText="mm/dd/yyyy"
                          onChange={(date) =>
                            setFilter({
                              ...filter,
                              name: null,
                              tag: null,
                              page: 1,
                              date: date,
                            })
                          }
                          className="search_calendar_Box"
                          onKeyDown={(e) => handleKeyDown(e)}
                        />
                      ) : option === "Name" ? (
                        <input
                          type="text"
                          value={name}
                          className="search_boxs"
                          placeholder="enter name"
                          maxLength={150}
                          onKeyDown={(e) => handleKeyDown(e)}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              date: null,
                              tag: null,
                              page: 1,
                              name: e.target.value,
                            })
                          }
                        />
                      ) : option === "Tag" ? (
                        <input
                          type="text"
                          value={tag}
                          className="search_boxs"
                          placeholder="enter tag"
                          onKeyDown={(e) => handleKeyDown(e)}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              date: null,
                              name: null,
                              page: 1,
                              tag: e.target.value,
                            })
                          }
                        />
                      ) : (
                        <div style={{ width: "100px" }}></div>
                      )}
                    </div>
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon mt-1"
                      alt="Search"
                      style={{
                        opacity:
                          filter.name || filter.tag || filter.date ? 1 : 0.5,
                        cursor:
                          filter.name || filter.tag || filter.date
                            ? "pointer"
                            : "not-allowed",
                      }}
                      onClick={(e) => {
                        // Only trigger search if one of the fields has a value
                        if (filter.name || filter.tag || filter.date) {
                          setQuery([]);
                          setFilter({
                            ...filter,
                            searchClick: !filter.searchClick,
                          });
                        }
                      }}
                    />
                  </div>
                  <div className="mr-1 ml-1">
                    <img
                      src="/images/black_filter_icon.svg"
                      alt=""
                      onClick={(e) => setClick1(true)}
                    />
                  </div>
                  <div className="query_status_img">
                    {click1 && (
                      <FilterBox
                        setChecked={setChecked}
                        checked={checked}
                        setFilter={setFilter}
                        filter={filter}
                        setClick1={setClick1}
                        setQuery={setQuery}
                      />
                    )}
                  </div>
                  <p
                    style={{
                      margin: "4px 5px",
                      color: "#f88409",
                      fontWeight: "500",
                      fontSize: "14px",
                      textDecoration: "underline",
                      width: "16%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleRefresh()
                      setActiveHeader('all')
                      setOption("tag");
                    }}
                  >
                    Clear Search
                  </p>
                  <button
                    style={{
                      border: "none",
                      color: "white",
                      backgroundColor: "#74be65",
                      borderRadius: "5px",
                      padding: "5px 13px",
                      fontSize: "12px",
                      fontWeight: "600",
                      marginRight: "15px",
                    }}
                    onClick={() => {
                      handleRefresh()
                      setActiveHeader('all')
                      setOption("tag");
                    }}
                  >
                    Refresh
                  </button>
                </div>
              </>
            )}
        </div>
      </div>
      {(Object.keys(editQueryData).length > 0 || click) && (
        <div
          className="fixed top-0 start-0 w-full h-full d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="bg-white rounded-3 shadow-lg flex w-full"
            style={{
              // width: "90vw",
              maxWidth: "900px",
              height: "70vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Body */}
            <div className=" overflow-auto w-full">
              <CreateNewQuery
                editQueryData={editQueryData}
                setEditQueryData={setEditQueryData}
                socket={socket}
                change={setClick}
                headerChange={change}
                groupData={groupData}
              />
            </div>
          </div>
        </div>
      )}

      {/* {(Object.keys(editQueryData).length > 0 || click) && (
        <CreateNewQuery
          editQueryData={editQueryData}
          setEditQueryData={setEditQueryData}
          socket={socket}
          change={setClick}
          headerChange={change}
          groupData={groupData}
        />
      )} */}
      {
        openImg && <DetailsImagePopup setOpenImg={setOpenImg} imgSrc={queryImage} />
      }
    </div>
  );
};

export default QueryHeader;
